import { Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from "@mui/material";
import ProButton from "../../../../Components/ProButton";

const ConfirmDialog = ({ open, title, description, onClose, onConfirm, confirmText = "Confirm", cancelText = "Cancel" }) => (
  <Dialog open={open} onClose={onClose} aria-describedby="alert-dialog-description">
    <DialogTitle>{title}</DialogTitle>
    <DialogContent>
      <DialogContentText id="alert-dialog-description">{description}</DialogContentText>
    </DialogContent>
    <DialogActions>
      {cancelText && (
        <ProButton variant="outlined" onClick={onClose}>
          {cancelText}
        </ProButton>
      )}
      {onConfirm && (
        <ProButton variant="contained" onClick={onConfirm}>
          {confirmText}
        </ProButton>
      )}
    </DialogActions>
  </Dialog>
);
export default ConfirmDialog;